{
	"cardHeader": "Få åtkomst till dina deklarationer",
	"supplierTitle": "Är du leverantören av en evoZero-deklaration?",
	"supplierDescription": "Hantera deklarationerna för dina evoZero-material.",
	"loginButton": "Logga in"
}
